import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { CoreModule } from '@abp/ng.core';
import { KENDO_DATETIMEPICKER } from '@progress/kendo-angular-dateinputs';
import { KENDO_TEXTAREA, KENDO_TEXTBOX } from '@progress/kendo-angular-inputs';
import { KENDO_FLOATINGLABEL } from '@progress/kendo-angular-label';

import { RespondToActivationRequest } from '../../../models';

@Component({
  selector: 'nexweb-decline-form',
  templateUrl: './decline-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CoreModule, KENDO_TEXTBOX, KENDO_FLOATINGLABEL, KENDO_DATETIMEPICKER, KENDO_TEXTAREA],
})
export class DeclineFormComponent implements OnInit {
  @Input() notification: RespondToActivationRequest.Notification;
  @Input() labels: RespondToActivationRequest.NotificationLabels;
  @Input() heading: string;
  @Input() dateTimeFormat: string;

  public notificationFormGroup: FormGroup;

  constructor() {}

  ngOnInit(): void {
    this.initialise();
  }

  public initialise(): void {
    this.notificationFormGroup = new FormGroup({
      instrument: new FormControl({
        value: this.notification.instrument,
        disabled: true,
      }),
      activatingPortfolio: new FormControl({
        value: this.notification.activatingPortfolio,
        disabled: true,
      }),
      supplyingBspPortfolio: new FormControl({
        value: this.notification.supplyingBspPortfolio,
        disabled: true,
      }),
      activatedQuantity: new FormControl({
        value: this.notification.activatedQuantity,
        disabled: true,
      }),
      timeRequestWasDeclined: new FormControl({
        value: this.notification.timeRequestWasDeclined,
        disabled: true,
      }),
      reasonForDeclining: new FormControl({
        value: this.notification.reasonForDeclining,
        disabled: true,
      }),
      // acknowledgeMessageRead: new FormControl({
      //   value: false,
      // }),
    });
  }
}
